module.exports = "/images/Icon industry-EntertaimentCenter.svg?f8f529bb156a18b322bae14ed6e21a7e";